import { FunctionComponent } from 'react';

import SectionsHeroBlack from 'components/content/sections/HeroBlack/component';

import StyledComponent from './styles';
import { Props } from './types';

const PageCoursesSectionHero: FunctionComponent<Props> = ({ translations }) => {
    return (
        <StyledComponent className="page-courses-section-hero">
            <SectionsHeroBlack
                headline={translations?.headline}
                subheadline={translations?.subheadline}
            />
        </StyledComponent>
    );
};

export default PageCoursesSectionHero;
